import { call, put, takeEvery } from "redux-saga/effects"
import { dotDangKyDichVuApi } from "../../api/dotDangKyDichVuApi"
import { IBaseResponeModel } from "../../models/response/base-response"
import { DotDangKyDichVuActionTypeIds, DotDangKyDichVuDeleteStartAction, DotDangKyDichVuSaveStartAction } from "../action-types/dotDangKyDichVuActionTypes"
import {
    loadDotDangKyDichVuError, loadDotDangKyDichVuSuccess, saveDotDangKyDichVuError, saveDotDangKyDichVuSuccess,
    deleteDotDangKyDichVuSuccess, deleteDotDangKyDichVuError
} from "../actions/dotDangKyDichVuActions"
export function* dotDangKyDichVuSaga(): any {
    yield takeEvery(DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_LOAD_START, loadDotDangKyDichVuStartWorker)
    yield takeEvery(DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_SAVE_START, saveDotDangKyDichVuStartWorker)
    yield takeEvery(DotDangKyDichVuActionTypeIds.DOTDANGKYDICHVU_DELETE_START, deleteDotDangKyDichVuStartWorker)
}
function* loadDotDangKyDichVuStartWorker() {
    const res: IBaseResponeModel = yield call(dotDangKyDichVuApi.select_all)
    if (res.is_success) {
        yield put(loadDotDangKyDichVuSuccess(res.data))
    } else {
        yield put(loadDotDangKyDichVuError(res.message || ""))
    }
}
function* saveDotDangKyDichVuStartWorker(data: DotDangKyDichVuSaveStartAction) {
    let res: IBaseResponeModel;
    if (data.payload.id > 0) {
        res = yield call(dotDangKyDichVuApi.update, data.payload)
    } else {
        res = yield call(dotDangKyDichVuApi.insert, data.payload)
    }
    if (res.is_success) {
        if (data.payload.id > 0 && res.data==0) {
            yield put(deleteDotDangKyDichVuError("Không thể cập nhật dữ liệu vì đã tồn tại dữ liệu đăng ký"))
        }else{
            yield put(saveDotDangKyDichVuSuccess(data.payload))
            yield call(loadDotDangKyDichVuStartWorker)
        }
       
    } else {
        yield put(saveDotDangKyDichVuError(res.message || ""))
    }
}
function* deleteDotDangKyDichVuStartWorker(data: DotDangKyDichVuDeleteStartAction) {
    var ids = [data.payload];
    const res: IBaseResponeModel = yield call(dotDangKyDichVuApi.delete, ids)
    if (res.is_success) {
        if (res.data==0) {
            yield put(deleteDotDangKyDichVuError("Không thể xóa đợt đăng ký vì đã tồn tại dữ liệu đăng ký"))
        }else{
            yield put(deleteDotDangKyDichVuSuccess(data.payload))
            yield call(loadDotDangKyDichVuStartWorker)
        }
    } else {
        yield put(deleteDotDangKyDichVuError(res.message || ""))
    }
}